"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuickActionsPanel = void 0;
var _react = _interopRequireDefault(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var QuickActionsPanel = exports.QuickActionsPanel = function QuickActionsPanel(_ref) {
  var isVisible = _ref.isVisible,
    isExpanded = _ref.isExpanded,
    onToggleExpanded = _ref.onToggleExpanded,
    title = _ref.title,
    actionButton = _ref.actionButton,
    expandedContent = _ref.expandedContent,
    _ref$expandedContentH = _ref.expandedContentHeight,
    expandedContentHeight = _ref$expandedContentH === void 0 ? null : _ref$expandedContentH,
    _ref$zIndex = _ref.zIndex,
    zIndex = _ref$zIndex === void 0 ? 2 : _ref$zIndex;
  if (!isVisible) return null;
  var expandedSizing = expandedContentHeight === null ? {
    maxHeight: isExpanded ? '300px' : '0'
  } : {
    height: isExpanded ? "".concat(expandedContentHeight, "px") : '0',
    overflowY: 'hidden'
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col bg-transparent overflow-visible transition-all duration-200 w-full mb-2",
    style: {
      zIndex: zIndex
    },
    "data-sentry-component": "QuickActionsPanel",
    "data-sentry-source-file": "QuickActionsPanel.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex items-center justify-between h-[38px] px-3 gap-2 bg-background-primary-canvas border border-primary/30 border-b-0 rounded-t-md shadow-sm",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex items-center gap-2 flex-1 min-w-0",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          onClick: onToggleExpanded,
          className: "bg-transparent border-none text-[#686766] cursor-pointer p-0 flex items-center justify-center flex-shrink-0 w-4 h-4 hover:text-[#4a5568] transition-colors",
          children: isExpanded ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.KeyboardArrowDownIcon, {
            width: 16,
            height: 16
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ChevronRightIcon, {
            width: 16,
            height: 16
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "text-xs text-[#686766] font-medium whitespace-nowrap overflow-hidden text-ellipsis",
          children: title
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "flex-shrink-0",
        children: actionButton
      })]
    }), expandedContent && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "overflow-y-auto transition-all duration-300 ease-in-out scrollbar-thin scrollbar-thumb-[#D4C5B1] scrollbar-track-transparent bg-white border-x border-b border-t border-primary/30 rounded-b-md shadow-sm",
      style: _objectSpread(_objectSpread({}, expandedSizing), {}, {
        padding: isExpanded ? '8px 12px' : '0 12px',
        opacity: isExpanded ? 1 : 0,
        visibility: isExpanded ? 'visible' : 'hidden'
      }),
      children: expandedContent
    })]
  });
};